import i18n from '@/i18n';
import { REGIMENES_SET } from '@/constants/regimenesConstants';

const { t } = i18n.global;

export function getNombreTipoRegimen(nombre) {
  if (!nombre) return '';
  if (REGIMENES_SET.has(nombre)) {
    return t(`reserva.tipo.${nombre}`);
  }
  return nombre;
}
